import { PasswordStrengthLevel } from '@components/PasswordStrength/PasswordStrength.types';
import { FieldError } from 'react-hook-form';

export const calculatePasswordStrength = (
  error: FieldError | undefined,
  value: string | undefined
): PasswordStrengthLevel => {
  if (value === undefined || value === '') return PasswordStrengthLevel.None;

  if (!error) return PasswordStrengthLevel.Strong;

  const errors = error.message?.split('.') ?? [];
  if (errors.length > 2) return PasswordStrengthLevel.Weak;
  else if (errors.length >= 1) return PasswordStrengthLevel.Medium;
  else return PasswordStrengthLevel.Strong;
};
